import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { browserHistory } from "browser-history";
import { aLink } from "utils/styles";
import { Portal } from "react-portal";
import PropTypes from "prop-types";
import * as storage from "utils/storage";

class ErrorBoundary extends Component {
  state = { error: null, errorInfo: null, feedbackMessage: "", feedbackSent: false };

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    this.captureException(error, errorInfo);
  }

  resetError = () => {
    browserHistory.push("/dashboard");
    this.setState({ error: false, errorInfo: false, feedbackMessage: "", feedbackSent: false });
  };

  captureException = (error, errorInfo) => {
    const serializedUser = storage.get("evergreen");
    const user = JSON.parse(serializedUser) || {};
    console.error("ErrorBoundary caught an error", {
      error,
      errorInfo,
      userId: user.id,
      location: window.location.href
    });
    try {
      if (typeof window.newrelic?.noticeError === "function") {
        window.newrelic.noticeError(error, {
          componentStack: errorInfo.componentStack,
          userId: user.id,
          location: window.location.href
        });
      }
    } catch (e) {
      console.error("Failed to report error to New Relic", e);
    }
  };

  submitFeedback = () => {
    const { feedbackMessage, error, errorInfo } = this.state;
    const serializedUser = storage.get("evergreen");
    const user = JSON.parse(serializedUser) || {};
    try {
      if (typeof window.newrelic?.addPageAction === "function") {
        window.newrelic.addPageAction("ErrorBoundaryFeedback", {
          message: feedbackMessage,
          userId: user.id,
          errorMessage: error ? error.toString() : "",
          componentStack: errorInfo ? errorInfo.componentStack : "",
          location: window.location.href
        });
      }
    } catch (e) {
      console.error("Failed to send feedback to New Relic", e);
    }
    this.setState({ feedbackSent: true });
  };

  render() {
    const { error, errorInfo, feedbackMessage, feedbackSent } = this.state;
    if (error) {
      return (
        <React.Fragment>
          <Portal>
            <div className="error-boundary-underlay" />
          </Portal>
          <div className="error-boundary">
            <div className="error-boundary-error" />
            <h1>Error</h1>
            <h2>Woops! Sorry something went wrong.</h2>
            <div className="error-actions">
              <div style={aLink} onClick={this.resetError}>
                Back to homepage
              </div>
              <div className="feedback-link">
                {feedbackSent ? (
                  <p>Thank you for your feedback.</p>
                ) : (
                  <div>
                    <textarea
                      placeholder="What were you doing when this happened?"
                      value={feedbackMessage}
                      onChange={e => this.setState({ feedbackMessage: e.target.value })}
                      rows={3}
                      style={{ width: "100%", marginTop: "8px" }}
                    />
                    <div
                      style={{ ...aLink, opacity: feedbackMessage.trim() ? 1 : 0.4 }}
                      onClick={feedbackMessage.trim() ? this.submitFeedback : undefined}
                    >
                      Send Feedback
                    </div>
                  </div>
                )}
              </div>
              <details>
                {error.toString()}
                {errorInfo.componentStack.toString()}
              </details>
            </div>
          </div>
        </React.Fragment>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default withRouter(ErrorBoundary);
